import { ProjectMapper } from '../mapper/ProjectMapper';

export const projectMapper = new ProjectMapper();
